import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDayTankRecordList, updateShiftTankRecord } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import { formatTimeToStr } from '@/utils/date';
import { mapGetters } from "vuex";
import { updateDayTankRecord } from "../../api/bairun/oilpsiManage";

var _this;

export default {
  name: 'DayTankRecord',
  components: {},
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getDayTankRecordList,
      searchInfo: {
        stationId: '',
        tankNum: '',
        stationName: '',
        oilCode: ''
      },
      tableData: [],
      page: 1,
      pageSize: 31,
      total: 0,
      stationOptions: [],
      stationTankOptions: [],
      stationTankOptionsTemp: [],
      merge: [],
      // 存放需要合并的行
      mergeRowIndex: '',
      // 需要合并行下标
      updateMerge: [],
      // 存放需要合并的行
      updateMergeRowIndex: '',
      // 需要合并行下标
      dialogVisible: false,
      updateTableData: [],
      formData: {
        stationId: 0,
        dailyNo: '',
        dailyDate: '',
        tankInNo: '',
        shiftOilHeight: 0,
        shiftWaterHeight: 0,
        shiftOilCapacity: 0,
        totalLastDailyLiters: '',
        oilTankNo: '',
        tankNum: '',
        oilCode: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, stationTankOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;

                if (_this3.stationOptions.length > 0) {
                  _this3.searchInfo.stationId = _this3.stationOptions[0].ID;
                  _this3.searchInfo.stationName = _this3.stationOptions[0].stationName;
                }

                _context3.next = 7;
                return getStationOilTankInfoList({
                  page: 1,
                  pageSize: 9999
                });

              case 7:
                stationTankOptions = _context3.sent;
                _this3.stationTankOptions = stationTankOptions.data.list;

                _this3.onStationChange();

                _this3.onReset();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                _context4.next = 4;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this4.searchInfo));

              case 4:
                table = _context4.sent;

                if (table.code === 0 && table.data.list != null) {
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;

                  _this4.getSpanArr(table.data.list);

                  _this4.tableData = table.data.list;

                  _this4.$forceUpdate();
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 31;

      if (!this.searchInfo.stationId) {
        return;
      }

      if (!this.searchInfo.tankNum) {
        return;
      }

      if (!this.searchInfo.month || this.searchInfo.month === '') {
        return;
      }

      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {
        stationId: '',
        tankNum: '',
        stationName: '',
        oilCode: '',
        month: ''
      };
      var now = new Date();
      var month = now.getMonth() + 1;
      this.$set(this.searchInfo, 'month', now.getFullYear() + '-' + (month >= 10 ? month : '0' + month));

      if (this.stationOptions.length > 0) {
        this.searchInfo.stationId = this.stationOptions[0].ID;
        this.searchInfo.stationName = this.stationOptions[0].stationName;
      }

      if (this.stationTankOptionsTemp.length > 0) {
        this.searchInfo.tankNum = this.stationTankOptionsTemp[0].tankNum;
        this.searchInfo.oilCode = this.stationTankOptionsTemp[0].oilCode;
      }

      this.onSubmit();
    },
    getSpanArr: function getSpanArr(data) {
      this.merge = [];
      this.mergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.merge.push(1);
          this.mergeRowIndex = 0;
        } else {
          if (data[i].dailyNo === data[i - 1].dailyNo) {
            this.merge[this.mergeRowIndex] += 1;
            this.merge.push(0);
          } else {
            this.merge.push(1);
            this.mergeRowIndex = i;
          }
        }
      }
    },
    tableCellMerge: function tableCellMerge(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      console.log('tableCellMerge');

      if (['dailyNo', 'dailyDate', 'totalLastDailyLiters', 'totalOilSales', 'checkTotalLastDailyLiters', 'shiftOilHeight', 'shiftWaterHeight', 'shiftOilCapacity', 'cumulativeOilLossLiters', 'currentCumulativeOilLossLiters'].includes(column.property)) {
        var _row = this.merge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        debugger;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    getUpdateSpanArr: function getUpdateSpanArr(data) {
      this.updateMerge = [];
      this.updateMergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.updateMerge.push(1);
          this.updateMergeRowIndex = 0;
        } else {
          if (data[i].shiftNo === data[i - 1].shiftNo) {
            this.updateMerge[this.updateMergeRowIndex] += 1;
            this.updateMerge.push(0);
          } else {
            this.updateMerge.push(1);
            this.updateMergeRowIndex = i;
          }
        }
      }
    },
    updateTableCellMerge: function updateTableCellMerge(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;
      console.log('updateTableCellMerge');

      if (['dailyNo', 'dailyDate', 'totalLastDailyLiters', 'shiftOilHeight', 'shiftWaterHeight', 'shiftOilCapacity'].includes(column.property)) {
        var _row = this.updateMerge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    onInputDecimal: function onInputDecimal(e) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
      this.$forceUpdate();
    },
    onExport: function onExport() {},
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    onStationChange: function onStationChange() {
      var _this5 = this;

      this.stationTankOptionsTemp = this.stationTankOptions.filter(function (item) {
        return item.stationId == _this5.searchInfo.stationId;
      });
      this.stationOptionsTemp = this.stationOptions.filter(function (item) {
        return item.ID == _this5.searchInfo.stationId;
      });
      this.searchInfo.stationName = this.stationOptionsTemp[0].stationName;

      if (this.stationTankOptionsTemp.length > 0) {
        this.searchInfo.tankNum = this.stationTankOptionsTemp[0].tankNum;
        this.searchInfo.oilCode = this.stationTankOptionsTemp[0].oilCode;
      } else {
        this.searchInfo.tankNum = '';
        this.searchInfo.oilCode = '';
      }

      this.onSubmit();
    },
    onTankChange: function onTankChange() {
      var _this6 = this;

      var selTank = this.stationTankOptionsTemp.filter(function (item) {
        return item.tankNum == _this6.searchInfo.tankNum;
      });

      if (selTank && selTank.length > 0) {
        this.searchInfo.tankNum = selTank[0].tankNum;
        this.searchInfo.oilCode = selTank[0].oilCode;
      } else {
        this.searchInfo.tankNum = '';
        this.searchInfo.oilCode = '';
      }

      this.onSubmit();
    },
    onRowEdit: function onRowEdit(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getDayTankRecordList({
                  'dailyNo': row.dailyNo,
                  'stationId': row.stationId,
                  'tankNum': row.tankNum,
                  'page': 1,
                  'pageSize': 99999
                });

              case 2:
                res = _context5.sent;

                _this7.getUpdateSpanArr(res.data.list);

                _this7.updateTableData = res.data.list;
                _this7.formData.stationId = row.stationId;
                _this7.formData.dailyNo = row.dailyNo;
                _this7.formData.dailyDate = row.dailyDate;
                _this7.formData.tankInNo = row.tankInNo;
                _this7.formData.oilTankNo = row.oilTankNo;
                _this7.formData.tankNum = row.tankNum;
                _this7.formData.oilCode = row.oilCode;
                _this7.formData.shiftOilHeight = row.shiftOilHeight;
                _this7.formData.shiftWaterHeight = row.shiftWaterHeight;
                _this7.formData.shiftOilCapacity = row.shiftOilCapacity;
                _this7.formData.totalLastDailyLiters = row.totalLastDailyLiters;
                _this7.dialogVisible = true;

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    dialogClose: function dialogClose() {
      this.dialogVisible = false;
      this.previewDialogVisible = false;
      this.previewDialogImageUrl = '';
      this.updateTableData = [];
      this.formData = {
        stationId: 0,
        dailyNo: '',
        dailyDate: '',
        tankInNo: '',
        shiftOilHeight: 0,
        shiftWaterHeight: 0,
        shiftOilCapacity: 0,
        totalLastDailyLiters: '',
        oilTankNo: '',
        tankNum: '',
        oilCode: ''
      };
      this.getTableData();
    },
    dialogSave: function dialogSave() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = JSON.parse(JSON.stringify(_this8.formData));
                param.shiftOilHeight = Number(param.shiftOilHeight);
                param.shiftWaterHeight = Number(param.shiftWaterHeight);
                param.shiftOilCapacity = Number(param.shiftOilCapacity);
                param.totalLastDailyLiters = Number(param.totalLastDailyLiters);
                param.tankNum = Number(param.tankNum);
                param.oilCode = Number(param.oilCode);
                param.status = 2;
                param.bairunOilTankDailyDataDetailList = [];

                _this8.updateTableData.forEach(function (item) {
                  param.bairunOilTankDailyDataDetailList.push({
                    'ID': item.ID,
                    'tankInNo': item.tankInNo,
                    'giveInLiters': Number(item.giveInLiters),
                    'giveInTon': Number(item.giveInTon),
                    'giveInCompareLiters': Number(item.giveInCompareLiters),
                    'beforeOilHeight': Number(item.beforeOilHeight),
                    'beforeOilCapacity': Number(item.beforeOilCapacity),
                    'afterOilHeight': Number(item.afterOilHeight),
                    'afterOilCapacity': Number(item.afterOilCapacity),
                    'sequenceOilSales': Number(item.sequenceOilSales)
                  });
                });

                _context6.next = 12;
                return updateDayTankRecord(param);

              case 12:
                res = _context6.sent;

                if (res.code == 0) {
                  _this8.dialogVisible = false;
                }

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};